import http from '@/services/http';


class GoogleMapsService {
  constructor(merchantOptions) {
    this.merchantOptions = merchantOptions;
  }

  /** initializer */
  static init(store) {
    const merchantOptions = store.getters['merchant/merchant'].options;

    return new GoogleMapsService(merchantOptions);
  }


  async getAutoCompletePredictions(searchTerm, predictionType) {
    try {
      const payload = this.formatAutoCompleteRequest(searchTerm, predictionType);

      const response = await http.get('/google-api/autocomplete', payload);

      const locationPredictions = response.data.predictions;

      return locationPredictions.map(prediction => ({ display: prediction.description, value: prediction.place_id }));
    }
    catch (error) {
      throw error;
    }
  }


  // eslint-disable-next-line class-methods-use-this
  async getGeoLocation(searchTerm) {
    try {
      const payload = { params: { address: searchTerm } };

      const response = await http.get('/google-api/geocode', payload);

      return response.data.results[0];
    }
    catch (error) {
      throw error;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  async getPlaceDetails(placeId) {
    try {
      const payload = { params: { placeId } };

      const response = await http.get('/google-api/place-details', payload);

      return response.data.result;
    }
    catch (error) {
      throw error;
    }
  }


  formatAutoCompleteRequest(searchTerm, predictionType) {
    const merchantCountryCodes = this.merchantOptions.inMarketCountryCodes || 'US';

    const countryCodes = GoogleMapsService.formatCountryCodes(merchantCountryCodes);

    const params = { input: searchTerm, countryCodes };

    if (predictionType) {
      Object.assign(params, { types: predictionType });
    }

    return { params };
  }


  static formatCountryCodes(countryCodes) {
    const codeList = countryCodes.split(',');

    const formattedCountryCodes = codeList.reduce((curr, next, idx, arr) => {
      const countryCode = next.toLowerCase();

      const countryString = idx === arr.length - 1
        ? curr += `country:${countryCode}`
        : curr += `country:${countryCode}|`;

      return countryString;
    }, '');

    return formattedCountryCodes;
  }
}


export default GoogleMapsService;
